/**
 * CMNAV Pre-Order Countdown Timer
 * ================================
 * Reads data-preorder-end from [data-cmnav-preorder-box].
 * Updates the timer digits every second.
 * When expired: shows expired message, optionally disables ATC button.
 */
(function () {
  'use strict';

  var box = document.querySelector('[data-cmnav-preorder-box]');
  if (!box) return;

  var endStr = box.getAttribute('data-preorder-end');
  if (!endStr) return;

  var endDate = new Date(endStr);
  if (isNaN(endDate.getTime())) return;

  var digitsEl = box.querySelector('[data-cmnav-timer-digits]');
  var expiredEl = box.querySelector('[data-cmnav-expired]');
  var daysEl = box.querySelector('[data-cmnav-days]');
  var hoursEl = box.querySelector('[data-cmnav-hours]');
  var minutesEl = box.querySelector('[data-cmnav-minutes]');
  var secondsEl = box.querySelector('[data-cmnav-seconds]');

  if (!digitsEl || !daysEl || !hoursEl || !minutesEl || !secondsEl) return;

  var disableAtc = box.getAttribute('data-disable-atc') === 'true';
  var closedText = box.getAttribute('data-closed-button-text') || 'Pre-order closed';

  // Show the JS timer, hide noscript content
  digitsEl.style.display = '';

  // Inject hidden inputs into the product form
  injectLineItemProperties();

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function update() {
    var now = new Date();
    var diff = endDate.getTime() - now.getTime();

    if (diff <= 0) {
      onExpired();
      return;
    }

    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    daysEl.textContent = pad(days);
    hoursEl.textContent = pad(hours);
    minutesEl.textContent = pad(minutes);
    secondsEl.textContent = pad(seconds);
  }

  function onExpired() {
    clearInterval(intervalId);
    digitsEl.style.display = 'none';
    if (expiredEl) {
      expiredEl.style.display = '';
    }

    if (disableAtc) {
      var atcBtn = document.querySelector('[data-product-atc-preorder]');
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.classList.add('disabled');
        var textEl = atcBtn.querySelector('.atc-button--text');
        if (textEl) {
          textEl.textContent = closedText;
        }
      }
    }
  }

  function injectLineItemProperties() {
    var template = document.querySelector('[data-cmnav-preorder-properties]');
    if (!template) return;
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var clone = template.content.cloneNode(true);
    form.appendChild(clone);
  }

  // Initial update + interval
  update();
  var intervalId = setInterval(update, 1000);
})();
